<template>
  <v-select
    :return-object="false"
    :items="options"
    v-model="innerValue"
    item-text="text"
    item-value="value"
    v-bind="resetProps"
    clearable
    @blur="emitBlur"
  />
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    items: Array,
    value: String,
  },
  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },
  computed: {
    ...mapState({
      USStates: (state) => state.account.states,
    }),
    resetProps() {
      return { ...this.$attrs  };
    },
    options() {
        return this.USStates.map(state => {
            return {
                ...state,
                text: state.name,
                value: state.code
            }
        })
    }
  },

  methods: {
    emitBlur() {
      this.$emit("blur");
    },
  },
  data() {
    return {
      innerValue: this.value
    };
  },
};
</script>